/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../../hooks/useForm';
import systemAlert from '../../../utils/systemAlert';
import { isEmpty } from '../../../utils/lodashExtend';
import Filters from '../../../components/Filters';
import { ControlTable } from '../../../components/Table';
import { useSelector } from 'react-redux';
import { getParams } from '../../../utils/params';
import { getCollaborations } from '../../../apis/tax-portal/tax-consulting';
import Profile from '../../../components/Profile';
import Icon from '../../../components/Icon';
import CommentIcon from "../../../assets/images/icon/comment-icon.svg";
import { COUNSELING_SEARCH_OPTIONS } from '../../../constants/COUNSELING';
import TaxConsultingCollaborationDetail from './TaxConsultingCollaborationDetail';
import { toast } from '../../../utils/toast';

const TaxConsultingCollaborations = (props) => {
  const { employee } = useSelector((store) => ({
    employee: store.Profile.employee,
  }));


  const { type } = props;
  const [tableButtons, setTableButtons] = useState();
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [filters, setFilters] = useState([]);

  const [fields, setFields] = useState([]);
  const [mode, setMode] = useState("create");
  const [categoryName, setCategoryName] = useState('');

  const {
    form,
    setForm,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit
  } = useForm({
    order: [
      {
        createdTime: "desc"
      },
    ],
    page: 0,
    limit: 10,
  });

  const submit = (form) => {

    let params = getParams(form);
    params = {
      ...params,
      search: {
        ...params.search,
        ...(type === "request" && { writerEmployeeIdx: employee.employeeIdx }),
        ...(type === "received" && { targetEmployeeIdx: employee.employeeIdx }),
      }
    };

    getCollaborations(params)
      .then(res => {
        const { comment } = res;
        setList(res.list.map(item => {
          return {
            ...item,
            comments: comment?.listByPost?.find(c => c.postIdx === item.idx) || {}
          };
        }));
        setTotal(res.count);
      }).finally(() =>
        setIsLoading(false));
  };

  const getFields = () => {
    const _fields = [
      {
        title: "카테고리",
        key: "category",
        onValue: (value) => {
          return `${value.parentCategory ? `${value.parentCategory?.name}-` : ""}${value.name}`;
        },
      },
      {
        title: "대상 회사",
        key: "targetCompany.name",
        isHide: () => type === "received"
      },
      {
        title: "요청 회사",
        key: "company.name",
        isHide: () => type === "request"
      },
      {
        title: "제목",
        key: "title",
        onValue: (value, _, d) => {

          const isNew = (employee.companyIdx !== d.writerEmployee?.companyIdx && isEmpty(d.viewEmployee));

          const isUpdate = (
            // 수정여부
            (employee.companyIdx !== d.writerEmployee?.companyIdx && isEmpty(d.viewTime)) ||
            // 댓글 여부
            (d?.comments?.comments || []).find(f => employee.employeeIdx !== f.writerEmpIdx && !f.viewTime)
          );

          return (
            <>
              {value === 'null' || isEmpty(value) ? <span className="color-red-80">삭제된 게시글 입니다.</span> :
                <span className={`${!isNew && !isUpdate ? "" : "font-bold"}`}>
                  {value}
                </span>
              }

              {isNew ? !isEmpty(value) && <small className="color-red-100 font-size-10 ml-2 display-inline">new</small>
                : isUpdate ? !isEmpty(value) && <small className="color-red-100 font-size-10 ml-2 display-inline">edited</small> : <></>
              }
            </>
          );
        },
      },
      {
        title: "요청자",
        key: "employee",
        onValue: (data, fields, datas) => {
          return `${data?.company?.name ? `${data?.company?.name}-` : ""}${data?.name}`;
        }
      },
      { title: "작성일시", key: "createdTime", type: 'datetime' },
      {
        title: "읽은사람", key: "viewEmployee",
        onValue: (data, fields, datas) => {
          return data ? <Profile data={data} className={`${!datas.isManagerWrite ? 'font-bold' : ''}`} /> : '-';
        }
      },
      { title: "읽은시간", key: "viewTime", type: 'datetime' },
      {
        title: '',
        key: 'comments',
        onValue: (value) => {
          return (
            !isEmpty(value) ? (
              <>
                <Icon src={CommentIcon} />
                <span className="ml-4 font-bold">{value.count}</span>
              </>
            ) : (<></>)
          );
        }
      }];

    setFields(_fields);
  };

  useEffect(() => {
    if (!isEmpty(props) && employee && !isEmpty(type)) {
      setSelectedList([]);
      setSelectedItem(null);
      submit(form);
      setSubmit(submit);
      getFields();

    }
  }, [type, employee]);

  // fillter 만들기
  useEffect(() => {
    setFilters([
      {
        title: "카테고리",
        type: "input",
        key: "search.categoryName",

      },
      {
        title: "분류",
        type: "select",
        key: "searchType",
        options: {
          list: COUNSELING_SEARCH_OPTIONS,
        },
      },
      {
        title: "키워드 검색",
        type: "input",
        key: "searchText",
        placeholder: "검색어 입력",
      },
      {
        title: "요청 회사명 또는 직원명 검색",
        type: "input",
        key: "search.employeeAndCompany",
        placeholder: "요청 회사명 또는 직원명 입력"
      },
      // {
      //   title: "직원명 검색",
      //   type: "input",
      //   key: "search.employeeName",
      // },
      {
        title: "미확인 항목 보기",
        key: "unidentified",
        type: "checkbox",
        className: "margin-right-16",
        label: "미확인만 보기",
        checked: form.unidentified,
        onChange: (check) => {
          setForm({
            ...form,
            unidentified: check
          });
        }
      }
    ]);
  }, [form]);

  useEffect(() => {
    setTableButtons([
      {
        label: "일괄삭제",
        color: "red",
        disabled: isEmpty(selectedList),
        action: () => {
          if (selectedList.length > 0) {
            systemAlert(`"${selectedList[0].title}" ${selectedList.length - 1 > 0 ? ` 외 ${selectedList.length - 1}개` : ""}을(를) 삭제하시겠습니까?`, {
              buttons: [
                {
                  color: 'text',
                  label: '취소'
                },
                {
                  label: '삭제',
                  color: 'red',
                  onClick: () => {

                  }
                }
              ]
            });
          }
        },
      },
    ]);
  }, [selectedList]);


  const openDetail = (data, e) => {
    if (isEmpty(data.title)) {
      toast.info("삭제된 게시글 입니다.");
      return;
    }

    setCategoryName(`${data?.category?.parentCategory?.name}-${data?.category?.name}`);
    setMode("view");
    setSelectedItem(data);
    setDetailOpen(true);
  };

  const cancel = () => {
    setSelectedItem(null);
    setCategoryName("");
    setMode("create");
    reSubmit();
  };

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />

      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        selectedList={selectedList}
        setSelected={setSelectedList}
        // isControl={true}
        isHideControlHeader
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        buttons={tableButtons}
        onSelect={openDetail}
      />

      <TaxConsultingCollaborationDetail
        open={detailOpen}
        setOpen={setDetailOpen}
        data={selectedItem}
        submit={cancel}
        orgMode={mode}
        categoryName={categoryName}
      />
    </>
  );
};

export default TaxConsultingCollaborations;